<template>
  <v-card>
    <v-card-title>
      Adicionar Banner
    </v-card-title>
    <v-container>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-row>
          <v-col>
            <v-file-input
              accept="image/png"
              label="File input"
              placeholder="Selecione um banner"
              :rules="rules"
              name="file"
              v-model="file"
            >
            </v-file-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="primary" @click="onUpload">
              Criar banner
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </v-card>
</template>

<script>
import axios from "axios";
import { InsertBanners } from "../../graphql/banners.gql";

export default {
  name: "BannerAdd",
  props: {
    price: Object
  },
  data: () => ({
    url: "http://login.applysys.com.br/upload",
    file: null,
    lazy: false,
    valid: true,
    rules: [v => !!v || "Campo obrigatório!"]
  }),
  methods: {
    onUpload() {
      const formData = new FormData();
      formData.append("file", this.file);
      axios
        .post(this.url, formData, {
          headers: {
            "Content-Type": `multipart/form-data;`
          }
        })
        .then(data => {
          //console.log(this.price)
          this.$apollo
            .mutate({
              mutation: InsertBanners,
              variables: {
                title: this.price.name,
                order: 0,
                enabled: true,
                paid: false,
                id_drugstore: this.price.prices[0].id_drugstore,
                filename: data.data.filename,
                id_price: this.price.prices[0].id
              }
            })
            .then(data => {
              console.log(data);
            });
        });
    }
  }
};
</script>
